import { UserX } from 'lucide-react';

interface Props {
  onLogout: () => void;
}

export default function SystemAccountNotFoundScreen({ onLogout }: Props) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="text-center max-w-md px-6">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100">
          <UserX className="h-7 w-7 text-amber-600" />
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">Account Not Found</h1>
        <p className="text-sm text-gray-600 mb-6">
          Your identity was authenticated but no matching account was found in the system.
          Please contact your administrator to have your account created.
        </p>
        <p className="text-xs text-gray-400 mb-6">
          Signed in as: <span className="font-mono">{/* email shown by parent if needed */}</span>
        </p>
        <button
          type="button"
          onClick={onLogout}
          className="px-4 py-2 rounded-lg text-sm font-medium text-white bg-slate-800 hover:bg-slate-700 transition-colors"
        >
          Sign Out
        </button>
      </div>
    </div>
  );
}
